"use client"

import { useChat } from "@/context/ChatContext"
import { useEffect, useState } from "react"

/**
 * ConnectyCube allows one session per user.
 * Acquire exclusive ownership, wait until the background unread widget
 * has unmounted, then delay so teardown can finish before remounting.
 */
export function useExclusiveChatSession(
  owner: string,
  delayMs = 700
): boolean {
  const { acquireChatSession, releaseChatSession, isBackgroundChatEnabled } =
    useChat()
  const [ready, setReady] = useState(false)

  useEffect(() => {
    acquireChatSession(owner)
    return () => {
      setReady(false)
      releaseChatSession(owner)
    }
  }, [owner, acquireChatSession, releaseChatSession])

  useEffect(() => {
    if (isBackgroundChatEnabled) {
      setReady(false)
      return
    }

    const t = window.setTimeout(() => setReady(true), delayMs)
    return () => {
      window.clearTimeout(t)
      setReady(false)
    }
  }, [isBackgroundChatEnabled, delayMs])

  return ready
}
